import axios from 'axios'

const AuthenticationService = {
  async getAllUserRoles(dealerId) {
    try {
      const response = await axios.get(`/GetAllUserRoles/${dealerId}`)
      return response.data
    } catch (e) {
      return Promise.resolve()
    }
  },
  async postAdminAuthorization(params) {
    const { brand, dealerId, userPonId, roleName, action } = params

    return axios.post('PostAdminAuthorization', {
      brand,
      dealerId,
      userPonId,
      roleName,
      action,
    })
  },
  async deleteAdminAuthorization(params) {
    const { brand, dealerId, userPonId, roleName, action } = params

    return axios.post('DeleteAdminAuthorization', {
      brand,
      dealerId,
      userPonId,
      roleName,
      action,
    })
  },
}

export default AuthenticationService
